import clsx from 'clsx'
import React from 'react'
import {useSearchParams} from 'react-router-dom'
import {DEFAULT_PAGE} from '../../../../../../gori/constants'
import {useA1BatchesProvider} from '../../../../../../gori/providers'
import {TicketDetail, TicketList} from '../../../../a1'
import {A1_CONSTANTS} from '../../../core/constants'

type Props = {
  show: boolean
  handleClose: () => void
}

const TicketForumModal: React.FC<Props> = ({show, handleClose}) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const {ticketForum, setTicketForum} = useA1BatchesProvider()

  const handleCloseModal = () => {
    searchParams.set('page', DEFAULT_PAGE)
    A1_CONSTANTS.PARAMS_TICKET_FILTER.forEach((param) => searchParams.delete(param))
    setSearchParams(searchParams)
    setTicketForum((prev) => ({...prev, detailId: null}))
    handleClose()
  }

  const handleBack = () => {
    searchParams.delete('id')
    setSearchParams(searchParams)
    setTicketForum((prev) => ({...prev, detailId: null}))
  }

  return (
    <>
      <div className={clsx('ticket-forum', {show})}>
        {ticketForum?.detailId ? (
          <TicketDetail handleBack={handleBack} handleCloseModal={handleCloseModal} />
        ) : (
          <TicketList show={show} handleCloseModal={handleCloseModal} />
        )}
      </div>
      <div className='ticket-forum-overlay' onClick={handleCloseModal}></div>
    </>
  )
}

export {TicketForumModal}
